export default __webpack_public_path__ + "static/media/calender_Forward_icon_inactive.f338a67e.svg";